/**
 * COURE.QUIZ.SERVICE.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface QuizUserResponse { 
    id?: string;
    serviceProviderId?: string;
    questionId?: string;
    campaingId?: string;
    phoneNumber?: string;
    sessionId?: string;
    userResponse?: string;
    status?: string;
    dateCreated?: Date;
}